import { StatementStatus } from "./Statement";
import { Address } from "./Address";
import { GeoLocation, LocationIdentifiers } from "./GeoLocation";

export enum ResidentRole {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface UnitResident {
  id: string;
  contactId: string; // Foreign key to Contact (type === 'resident')
  name: string;
  email: string;
  phone?: string;
  isPrimary: boolean;
  role: ResidentRole;
  moveInDate: string;
  moveOutDate?: string;
}

export interface UnitStatement {
  id: string;
  period: string;
  amount: number;
  status: StatementStatus;
  dueDate: string;
}

export enum UnitStatus {
  Occupied = 'occupied',
  Vacant = 'vacant',
  Pending = 'pending',
}

export interface Unit {
  id: string;
  ownerId: string;
  buildingId: string;
  name: string;
  floor?: string;
  size?: number;
  bedrooms?: number;
  bathrooms?: number;
  shareNumerator: number;   // Numerator of service charge share fraction (e.g. 1 in 1/12)
  shareDenominator: number; // Denominator of service charge share fraction (e.g. 12 in 1/12)
  residents: UnitResident[];
  status: UnitStatus;
  notes?: string;
  createdAt: string;
  /**
   * When the current management company started managing this specific
   * unit. ISO 8601 `YYYY-MM-DD`. Additive, optional. When absent, the
   * unit inherits its parent `Building.managementStartDate`; when the
   * building also has no value, resident move-in defaults fall back to
   * today. Only set on a unit when it differs from the building-level
   * anchor (mid-block acquisitions, staggered onboarding, etc.).
   */
  managementStartDate?: string;
  recentStatements: UnitStatement[];
  /** Structured postal address for this specific unit — additive, optional. */
  address?: Address;
  /** Canonical physical location — additive, optional. */
  location?: GeoLocation;
  /** Derived identifiers (never canonical) — regenerable from `location`. */
  locationIdentifiers?: LocationIdentifiers;
}
